/* eslint-disable */
// eslint-disable-next-line import/prefer-default-export
export const data = {
    /// ////////////////////////////////////////////////////////////
    /// /////////////// Interrupt //////////////////////////////////
    /// ////////////////////////////////////////////////////////////
    Interrupt_header: <h4>EngagED Parent Portal Login Process (Internal/External)</h4>,
    Interrupt_p0: (
        <h5>
            To log in, you will{" "}
            <strong>
                <u>NOT</u>
            </strong>{" "}
            use your personal email.
        </h5>
    ),
    Interrupt_p1: (
        <>
            To log in, you will enter an email address comprised of your{" "}
            <strong>
                <u>username</u>
            </strong>{" "}
            followed by{" "}
            <strong>
                <u>@p.dcsdk12.org</u>
            </strong>{" "}
            on the login screen that follows.
            <br />
            For example: if <b>jsmith</b> is your username, you will enter{" "}
            <strong>
                <u>jsmith@p.dcsdk12.org</u>
            </strong>
            .
            <br />
            <br />
            Your password is the same as you use for accessing Infinite Campus (current parent) or the password you
            created during account setup for Open Enrollment (external parent).
        </>
    ),
    Interrupt_p2: (
        <strong>
            If you need assistance with your username or password, please go to{" "}
            <a href="https://password.dcsdk12.org" target="_blank">
                password.dcsdk12.org
            </a>
            .
        </strong>
    ),
    Interrupt_p3: (
        <>
            <b>If you are unable to access after following the above steps, please contact us:</b>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Parent Tech Support - English
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LFLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Parent Tech Support - Spanish
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LRLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Parent Tech Support - Chinese
            </a>
            <br />
            IT Support Center at <b>303.387.0001</b>
        </>
    ),
    Interrupt_note:
        "NOTE: District employees who are current parents should follow the instructions above using an incognito or private browser window and/or different browser.",
    Interrupt_submit: "Proceed to Login",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Header //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Main_Nav_Welcome: "Welcome,",
    Main_Nav_HelpfulLinks: "Helpful Links",
    Main_Nav_LogOut: "LOGOUT",
    Main_Nav_HelpfulLinks_LI_s1: "Contact My Student(s) Nurse",
    Main_Nav_HelpfulLinks_LI_s2: "Academic Calendars",
    Main_Nav_HelpfulLinks_LI_s3: "Parent Resources",
    Main_Nav_HelpfulLinks_LI_s4: "Bus Routes",
    Main_Nav_HelpfulLinks_LI_s5: "Online Payments",
    Main_Nav_HelpfulLinks_LI_s6: "Lunch Menus",
    Main_Nav_Exit: "EXIT",
    Global_Dashboard: "Dashboard",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Breadcrumb //////////////////////////////
    /// /////////////////////////////////////////////////////////
    Breadcrumb: "DCSD Guardian Dashboard",
    Breadcrumb_Back: "DCSD Engaged Parent Portal",
    Breadcrumb_EPR: "DCSD Archived EPRs",
    Breadcrumb_Translations: "Translations are experimental",
    Breadcrumb_School_Selection: "Student School Selection",
    Breadcrumb_New_Student_Create: "New Student Create",
    Breadcrumb_Schools_Making_Offers: "Schools are Preparing Offers",
    /// /////////////////////////////////////////////////////////
    /// /////////////// OE //////////////////////////////////////
    /// /////////////////////////////////////////////////////////
    OE_Closed_Title: "Open Enrollment Window Closed",
    OE_Closed_Text:
        "The Open Enrollment window is now closed. Please return during the district's parent-access windows. Thank you.",
    OE_Student_Info_Breadcrumb: "Student & Guardian Information",
    OE_Student_Info_Guardian_Title: "Guardian's Current Information",
    OE_Student_Info_Student_Title: "Student's Current Information",
    OE_Student_Info_Email: "Email",
    OE_Student_Info_Address: "Address",
    OE_Student_Info_Phone: "Phone",
    OE_Student_Info_Current_School: "Current School",
    OE_Student_Info_Neighborhood_School: "Neighborhood School",
    OE_Student_Info_Scheduled_School: "Scheduled School for Next Year",
    OE_New_Student: "New Student",
    OE_Unavailable: "Unavailable",
    OE_Form_FirstName: "Student Legal First Name",
    OE_Form_FirstName_Description: "Use student's legal first name from birth certificate",
    OE_Form_MiddleName: "Student Legal Middle Name",
    OE_Form_MiddleName_Description: "Use student's legal middle name from birth certificate",
    OE_Form_LastName: "Student Legal Last Name",
    OE_Form_LastName_Description: "Use student's legal last name from birth certificate",
    OE_Form_Gender: "Gender",
    OE_Form_Gender_Male: "Male",
    OE_Form_Gender_Female: "Female",
    OE_Form_Gender_NonBinary: "Non-Binary",
    OE_Form_Birthdate: "Student Birthdate",
    OE_Form_Month: "Month",
    OE_Form_Example: "Example",
    OE_Form_Day: "Day",
    OE_Form_Year: "Year",
    OE_Form_Clear_Birthdate: "Clear Birthdate Fields",
    OE_Form_Student_Address: "Student's Legal Address",
    OE_Form_Student_Address_Description:
        "If you reside in Douglas County or Elbert County, please begin entering your address and select your address from the list of recommended addresses.",
    OE_Form_Search_Address: "Search Address",
    OE_Form_Apt_Or_Unit: "apartment or unit number",
    OE_Form_Select: "Select",
    OE_Form_Address1: "Address Line 1",
    OE_Form_Address2: "Address Line 2",
    OE_Form_City: "City",
    OE_Form_State: "State",
    OE_Form_Zip: "Zip Code",
    OE_Form_App_For_Grade: "Open Enrollment Application for Grade",
    OE_Form_App_For_Grade_Description1: "Based on the age your student will be in the", // [some variable school year range]
    OE_Form_App_For_Grade_Description2: "school year",
    OE_Form_App_For_Grade_Description3: (
        <>
            you will be applying for open enrollment to the grade in the <span className="yellow-box">yellow box</span>{" "}
            shown below. If the Applying For Grade is incorrect, please contact our Choice Programming Department{" "}
            <span className="bold">open-enrollmentusergroup@dcsdk12.org</span> to discuss your specific circumstances.{" "}
            <span className="will-be">
                If the Applying For Grade is incorrect <span className="bold">and</span> you proceed with school
                selections, your open enrollment request may be voided.
            </span>
        </>
    ),
    OE_Form_Current_Grade: "Current Grade",
    OE_Form_Applying_For_Grade: "Applying for Grade",
    OE_Form_Applying_For_Kindergarten:
        "The student will be applying for open enrollment to Kindergarten for next school year",
    OE_Form_Applying_For_Kinder_Title: "Applying for Kindergarten",
    OE_Form_Applying_For_Kinder_Body:
        "Please confirm that you want to adjust the Applying for Grade for the student from 1st Grade to Kindergarten. If you are making this adjustment after you have selected schools, these school selections will be deleted and you will need to complete new selections.",
    OE_Form_Reasons_For_Leaving: "Reasons for Leaving",
    OE_Form_Important: "Important",
    OE_Form_Important_Note: "Note: One or more reasons must be selected",
    OE_Form_Important_Reasons: "What are the reasons for leaving", // [some variable school name]
    OE_Form_Important_Other:
        'Note: If you select "Other" as a reason for applying, you must enter a comment in order to submit your school choice.',
    OE_Form_Address_Placeholder: "Start typing your address here",
    OE_Buttons_Delete: "Delete Open Enrollment",
    OE_Buttons_Back_To_Dashboard: "Back to Dashboard",
    OE_Buttons_Confirm_And_Proceed: "Confirm and Proceed",
    OE_Buttons_Cancel: "Cancel",
    OE_Buttons_Email: "Save and Email Me My Choices",
    OE_Dialog_Delete_Title: "Delete Open Enrollment Confirmation",
    OE_Dialog_Delete_Body1: "Please confirm that you would like to delete the Open Enrollment application for Student", // [some variable student name]
    OE_Dialog_Delete_Body2:
        "This action will remove any associated Open Enrollment school choice data for the student.",
    OE_Dialog_Back_Title1: "Open Enrollment Information Not Saved",
    OE_Dialog_Back_Title2: "Navigate to Guardian Dashboard",
    OE_Dialog_Back_Body1: "The Open Enrollment application has not yet been saved for Student", // [some variable student name]
    OE_Dialog_Back_Body2: "You will lose your progress if you elect to return to the Parent Dashboard.",
    OE_Dialog_Back_Body1a: "The Open Enrollment application has not yet been saved for your student.",
    OE_Schools_Title: "Participating Schools by Region (select up to 4 schools)",
    OE_Schools_Body:
        "Please select a district region to see a list of schools available for open enrollment. You must select at least one (1) school and may select a maximum of four (4) schools for open enrollment.",
    OE_Schools_Current_Address: "Current Address",
    OE_Schools_Selected: "selected",

    OE_Schools_My_Schools_Title: "My Selected Schools",
    OE_Schools_Selected_Schools_Header: "These are the schools that you have selected for Open Enrollment",
    OE_Schools_Selected_Schools_Body: (
        <>
            <h6>
                You <u>received offers</u> from the following schools:
            </h6>
            <span>
                You may accept one school offer. All other offers will automatically be declined. You may also decline
                any/all school offers.
            </span>
        </>
    ),
    OE_Schools_Selected_Schools_Body_2: (
        <>
            <h6>
                You will be added to the <u>waitlist</u> for the following schools:
            </h6>
            <span>
                During Round 2 of the Open enrollment Process, these school(s) may contact you directly to extend an
                offer of enrollment.
            </span>
        </>
    ),
    OE_Schools_Selected_Schools_None: "Your student does not have any school choices at the moment",
    OE_Schools_My_Schools_Body:
        'These are the schools that you have selected for Open Enrollment. For each school you selected, you must click the "Select Reasons" button to let us know what attracted you to apply for Open Enrollment at the school. Please note that you will not be able to save/email your school selections until you have entered at least one reason for applying for each selected school. To remove a school selection, click the trash can icon in the upper right hand corner of the school card.',
    OE_Schools_My_Schools_Grade: "Applying for Grade",
    OE_Schools_My_Schools_Status: "Status",
    OE_Schools_My_Schools_Select_Reasons: "Select Reasons",
    OE_Schools_My_Schools_Reasons_Title: "Reasons for Applying",
    OE_Schools_My_Schools_Reasons_Body: (
        <p>
            Please indicate{" "}
            <u>
                <strong>at least one</strong>
            </u>{" "}
            reason for applying for Open Enrollment at this school. You may indicate as many reasons as are applicable,
            and you may adjust at any time during the parent window.
        </p>
    ),
    OE_Schools_My_Schools_Note:
        'Note: If you select "Other" as a reason for applying, you must enter a comment in order to submit your school choice.',
    OE_Schools_My_Schools_Comment: "Please enter a comment",

    OE_Toast_Email_Error: "Unable to email confirmation to guardian.",
    OE_Toast_IC_Error: "There was a problem retrieving Student details from IC.",
    OE_Toast_Email: "Open Enrollment school choice(s) confirmation emailed to ", // [variable email address]
    OE_Toast_Email_Failure: "Unable to email school choice(s) confirmation as no valid guardian email exists.",
    OE_Toast_Deleted: "Open Enrollment application successfully deleted for student. Redirecting to Parent Dashboard.",
    OE_Toast_Saved: "School choices successfully saved. Redirecting to Parent Dashboard.",
    OE_Toast_Offer_Saved: "School choice offer acceptance and/or declination(s) successfully saved.",
    OE_Toast_Saved_Emailed:
        "School choice offer acceptance and/or declination(s) successfully saved. Redirecting to Parent Dashboard.",
    OE_Toast_Update_Error: "There was a problem updating you School Choices",
    OE_Toast_Delete_Error: "Unable to Delete Student Open Enrollment.",
    OE_Toast_Student_Updated: "Student information successfully updated for Open Enrollment.",
    OE_Toast_Data_Error: "There was a problem loading your data. Please reload the page and try again.",
    OE_Toast_Valid_Birthdate: "Please enter a valid date for student birthdate (MM-DD-YYYY).",
    OE_Toast_Student_Added: "Student successfully added for Open Enrollment.",
    OE_Toast_OE_Error: "Unable to Delete Student Open Enrollment.",
    OE_Toast_OE_Saved: "Successfully saved student information for Open Enrollment",
    OE_Toast_Student_Updated_2: "Successfully updated student information.",
    OE_Toast_Region_Error: "There was a problem retrieving Region Schools",
    OE_Toast_Student_Error: "There was a problem retrieving Student details",
    OE_Toast_Reasons_Error: "There was a problem retrieving Reasons for Applying",
    OE_Toast_School_Choice_Success: "School choice offer acceptance and/or declination(s) successfully saved.",
    OE_Toast_Redirecting: "Redirecting to Parent Dashboard",

    OE_Dialog_Window_Closed_Title: "Open Enrollment Window Closed",
    OE_Dialog_Window_Closed_Body:
        "The Open Enrollment window is now closed. Please return during the district's parent-access windows. Thank you.",
    OE_Dialog_Access_Denied_Title: "Access Denied",
    OE_Dialog_Access_Denied_Body:
        "Sorry, but you do not have permission to view this student. Please return to Parent Dashboard.",
    OE_Dialog_Ineligible_Title: "Date of Birth Ineligible for Open Enrollment",
    OE_Dialog_Ineligible_Body:
        "Based on the student's birthdate, the student's age is outside the range for open enrollment. Please contact the Choice Programming department to discuss the specific circumstances and/or options for open enrollment.",
    OE_Dialog_Processing: "Processing… Please Wait",

    OE_Modal_Ineligible: (
        <p>
            Based on the birthdate you entered, the{" "}
            <span className="age">student&apos;s age is outside the range for open enrollment</span>. Please contact the
            Choice Programming department to discuss the specific circumstances and/or options for open enrollment.
        </p>
    ),

    OE_Dialog_Incorrect_Info_Title: "Incorrect Student Information",
    OE_Dialog_Incorrect_Info_Body_1: "We are sorry that something is wrong with the student information for ", // [some variable student name]
    OE_Dialog_Incorrect_Info_Body_2: (
        <>
            <div className="top-sentence">
                Please follow the steps below before beginning your Open Enrollment request ...{" "}
            </div>
            <div className="number-container">
                <div className="number">1</div>
                <div className="instruction">
                    Please contact your student&apos;s school to request a data correction. The school may be able to
                    immediately process this request or it may take some time. Thank you for your patience.
                </div>
            </div>
            <div className="number-container">
                <div className="number">2</div>
                <div className="instruction">
                    Once you&apos;ve received confirmation from the school that the data correction has been completed,
                    please come back to begin your Open Enrollment request where you will have an opportunity to affirm
                    the accuracy of the updated student information.
                </div>
            </div>
            <div className="number-container">
                <div className="number">3</div>
                <div className="instruction">
                    Once you&apos;ve confirmed the accuracy of the information, you are invited to proceed with your
                    Open Enrollment request.
                </div>
            </div>
        </>
    ),

    OE_Buttons_Student_Info_Good: "Student Information Looks Good",
    OE_Buttons_Student_Info_Incorrect: "Student Information Incorrect",
    OE_Buttons_Save_Changes: "Save Changes",
    OE_Buttons_Continue: "Continue",
    OE_Buttons_Submit: "Submit",
    OE_Buttons_Accept: "Accept",
    OE_Buttons_Decline: "Decline",
    OE_Buttons_Delete: "Delete",
    OE_Buttons_Save: "Save",

    OE_Dialog_Choices_Will_Delete_Title: "Previous School Choice(s) Will Be Deleted",
    OE_Dialog_Choices_Will_Delete_Body: (
        <p>
            The change to the home address for this student may have resulted in a change to the schools available for
            Open Enrollment. As a result, any previous school selections will be deleted and you will need to re-select
            schools of interest after saving this change. Please confirm that you wish to continue OR click Cancel and
            contact the Choice Programming team at <span className="bold">open-enrollmentusergroup@dcsdk12.org</span> to
            discuss next steps.
        </p>
    ),
    OE_Dialog_Birthdate_Change_Body: (
        <p>
            The change to birthdate for this student has resulted in a change in the Applying To grade for Open
            Enrollment. As a result, you will need to re-select schools of interest after saving this change. Please
            confirm that you wish to continue.
        </p>
    ),

    OE_Buttons_Accept_Proceed: "Accept and Proceed",
    OE_Buttons_Should_Not_Match: "Names Should Not Match",
    OE_Modal_Names_Match_Title: "Student/Guardian Names Match Warning",
    OE_Modal_Names_Match_Body_1:
        "The first and last name you entered for the student matches the first and last name associated to your guardian account.",
    OE_Modal_Names_Match_Body_2: "Student Name Entered:",
    OE_Modal_Names_Match_Body_3: "Guardian Account Name:",
    OE_Modal_Names_Match_Note: "Note: Case sensitivity is disregarded",
    OE_Modal_Names_Correction_Title: "Matching Names Correction",
    OE_Modal_Names_Correction_Body: (
        <>
            <div>
                You indicated that the external guardian account you created used your student&apos;s first name and
                last name instead of your first name and last name. Before proceeding with Open Enrollment, please
                contact the IT Support Center at{" "}
                <strong>
                    <u>303-387-0001</u>
                </strong>{" "}
                to have your account information corrected.
            </div>
            <br />
            <div>
                <u>
                    Please note that the information you entered for the student will not be saved and will need to be
                    re-entered after your account information is corrected.
                </u>
            </div>
        </>
    ),
    OE_Next_Steps: "Next Steps",
    OE_Important_Parent_Info: "Important Parent Information",
    OE_Next_Steps_1: "DCSD schools have now extended offers for all Round 1 applications. Please note that you may or may not have received an offer of enrollment from your school choices. Please note that you may only accept one offer of enrollment at a time during this review window.",
    OE_Next_Steps_2: "DCSD schools are currently reviewing accepted offers from parents.",
    OE_Next_Steps_Post:
        "After accepting an offer, the school will contact you directly for next steps in the enrollment process. You do not need to contact the school as this may delay the process."
};
/* eslint-enable */
